import Stack from '@mui/material/Stack';
import { InsightsWarning } from './components/InsightsWarning/InsightsWarning';
import { MonthlyActiveReachEstimates } from './components/MonthlyActiveReachEstimates/MonthlyActiveReachEstimates';
import { MonthlyDeviceEstimates } from './components/MonthlyDeviceEstimates/MonthlyDeviceEstimates';
import { MonthlyRequestEstimates } from './components/MonthlyRequestEstimates/MonthlyRequestEstimates';
import { PublisherSection } from './components/PublisherSection/PublisherSection';
import { AudienceInsightsProvider } from './context/AudienceInsightsProvider';
import { useAudienceInsights } from './context/audienceInsights';

const AudienceInsightsContent = () => {
  const { isDisabled } = useAudienceInsights();

  return (
    <Stack>
      {isDisabled && <InsightsWarning />}
      <PublisherSection />

      {!isDisabled && (
        <>
          <MonthlyActiveReachEstimates />
          <MonthlyDeviceEstimates />
          <MonthlyRequestEstimates />
        </>
      )}
    </Stack>
  );
};

export function AudienceInsightsTab() {
  return (
    <AudienceInsightsProvider>
      <AudienceInsightsContent />
    </AudienceInsightsProvider>
  );
}
